import parseDateForLocal from './parseDateForLocal'
import store from "@/store"
import {DateTime} from "luxon"
// import parseDate from './parseDate'

export default function (dateIn, withTime) {
  // let date = parseDate(dateIn)
  //
  // if(!date) {
  //   date = parseDateForLocal(dateIn)
  // }

  let date = parseDateForLocal(dateIn)
  if (!date) return ''

  return formatNormalDate(date, withTime)
}

export function formatNormalDate(date, withTime) {
  if (typeof date === 'string') {
    date = new Date(date)
  }

  let day = date.getDate()
  if (isNaN(day)) return ''

  day = day.toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  let result = `${day}.${month}.${year}`

  if (withTime) {
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    result += `  ${hours}:${minutes}`
  }

  return result
}

export function formatTime(dateIn) {
  let date = parseDateForLocal(dateIn)
  if (!date) return ''

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}


export function formatDateForTimeTag(dateIn) {
  let date = parseDateForLocal(dateIn)
  if (!date) return ''

  let day = date.getDate()
  if (isNaN(day)) return ''

  day = day.toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()
  const hour = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${year}-${month}-${day}T${hour}:${minutes}`
}

export function formatDateAs(dateIn, format) {
  let date = parseDateForLocal(dateIn)

  if (!date) return ''
  if (!format) throw new Error('Please set date format for filter')

  const locale = store.state.locales[store.state.currentLocale]?.regional.replace('_', '-')
  return DateTime.fromJSDate(date).setLocale(locale).toFormat(format)
}
